import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import { BracesAsterisk, CameraReels, CodeSlash, UiRadiosGrid } from 'react-bootstrap-icons';

function HomeCenAbout() {
  return (
    <div>
      <Box>
        <Box>
          <Grid container spacing={2} style={{ padding: '1px 60px 1px 40px' }}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Typography variant='h4' sx={{ fontFamily: 'Roboto, Arial, sans-serif', fontWeight: 'bold', marginLeft: '6px' }}>
                About
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'left' }}>
              <Typography sx={{ fontFamily: 'Wittgenstein, serif', fontSize: '16px', lineHeight: '1.5' }}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aut, molestias quibusdam. Aliquid, dolorem ad. Ipsam, autem ipsa. Minima soluta exercitationem expedita pariatur, quas excepturi sequi, ipsa, cupiditate id dignissimos repudiandae.
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'left' }}>
              <Typography sx={{ fontFamily: 'Wittgenstein, serif', fontSize: '16px', lineHeight: '1.5' }}>
                Another paragraph of text can be added here. It will follow the same styling as the previous paragraph, ensuring consistency in the appearance of the content.
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={2} style={{ padding: '1px 60px 1px 40px' }}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Typography variant='h5' sx={{ fontFamily: 'Roboto, Arial, sans-serif', fontWeight: 'bold', marginLeft: '6px' }}>
                What I Do!
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: 'left', marginTop: '20px' }}>
              <Card sx={{ maxWidth: 350, height: 180, backgroundColor: '#b7dadd' }}>
                <CardContent style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Box sx={{ marginRight: 2 }}>
                    <CodeSlash size={35} style={{ color: '#6247aa' }} />
                  </Box>
                  <Box style={{ paddingRight: '10px' }}>
                    <Typography variant="h6" component="div" style={{ color: '#6247aa', fontFamily: 'Roboto, Arial, sans-serif' }}>
                      Web Developer
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} style={{ fontSize: '0.9rem', fontFamily: 'Roboto, Arial, sans-serif' }} color="text.secondary">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: 'left', marginTop: '20px' }}>
              <Card sx={{ maxWidth: 350, height: 180, backgroundColor: '#E7F0DC' }}>
                <CardContent style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Box sx={{ marginRight: 2 }}>
                    <UiRadiosGrid size={35} style={{ color: '#597445' }} />
                  </Box>
                  <Box style={{ paddingRight: '10px' }}>
                    <Typography variant="h6" component="div" style={{ color: '#597445', fontFamily: 'Roboto, Arial, sans-serif' }}>
                      UI/UX Designer
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} style={{ fontSize: '0.9rem', fontFamily: 'Roboto, Arial, sans-serif' }} color="text.secondary">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: 'left', marginTop: '20px' }}>
              <Card sx={{ maxWidth: 350, height: 180, backgroundColor: '#EBF4F6' }}>
                <CardContent style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Box sx={{ marginRight: 2 }}>
                    <CameraReels size={35} style={{ color: '#088395' }} />
                  </Box>
                  <Box style={{ paddingRight: '10px' }}>
                    <Typography variant="h6" component="div" style={{ color: '#088395', fontFamily: 'Roboto, Arial, sans-serif' }}>
                      Video Editor
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} style={{ fontSize: '0.9rem', fontFamily: 'Roboto, Arial, sans-serif' }} color="text.secondary">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: 'left', marginTop: '20px', marginBottom: '50px' }}>
              <Card sx={{ maxWidth: 350, height: 180, backgroundColor: '#EEEEEE' }}>
                <CardContent style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Box sx={{ marginRight: 2 }}>
                    <BracesAsterisk size={35} style={{ color: '#DC5F00' }} />
                  </Box>
                  <Box style={{ paddingRight: '10px' }}>
                    <Typography variant="h6" component="div" style={{ color: '#DC5F00', fontFamily: 'Roboto, Arial, sans-serif' }}>
                      Programmer
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} style={{ fontSize: '0.9rem', fontFamily: 'Roboto, Arial, sans-serif' }} color="text.secondary">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum ducimus suscipit
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  )
}

export default HomeCenAbout;
